import React from "react";
import { ArrowRight, Sparkles } from "lucide-react";
import BlueLogo from "./BlueLogo";

export const Hero = () => {
  const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

  return (
    <section id="top" className="relative pt-32 pb-20 md:pt-44 md:pb-32 overflow-hidden" data-testid="hero-section">
      {/* grid */}
      <div className="absolute inset-0 grid-bg pointer-events-none" />
      {/* glows */}
      <div className="absolute -top-40 left-1/2 -translate-x-1/2 w-[900px] h-[900px] rounded-full bg-brand/20 blur-[160px] pointer-events-none" />
      <div className="absolute top-1/3 -right-32 w-[500px] h-[500px] rounded-full bg-brand/10 blur-[120px] pointer-events-none" />

      <div className="relative max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex flex-col items-center text-center">
          <div className="chip mb-8 animate-fade-up" data-testid="hero-chip">
            <Sparkles size={12} className="text-brand" />
            <span>AI Precision Grading · No Human Error</span>
          </div>

          <BlueLogo size="xl" stacked showTagline className="mb-10 animate-fade-up" />

          <h1 className="font-display font-black text-4xl sm:text-5xl md:text-6xl lg:text-7xl tracking-tighter max-w-5xl leading-[0.95] animate-fade-up">
            <span className="text-white">Flawless precision.</span>
            <br />
            <span className="shimmer-text">Zero human error.</span>
          </h1>

          <p className="mt-8 max-w-2xl text-base md:text-lg text-white/60 font-body leading-relaxed animate-fade-up">
            The next era of sports card grading. Our proprietary AI vision analyzes every sub-grade with
            sub-pixel precision — delivering the most consistent, repeatable grades in the hobby.
          </p>

          <div className="mt-10 flex flex-col sm:flex-row gap-4 animate-fade-up">
            <button onClick={() => scrollTo("submit")} data-testid="hero-cta-primary" className="btn-primary">
              Start a Submission <ArrowRight size={16} />
            </button>
            <button onClick={() => scrollTo("how")} data-testid="hero-cta-secondary" className="btn-secondary">
              How the AI Works
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
